import {createSlice} from '@reduxjs/toolkit';
//types
import {IOrganizationTeamReducer} from '../../utils/types';
//actions
import {
	getTeamMembers,
	createTeamMemberPassword,
	updateMemberRole,
	deleteTeamMember,
	createTeamMember,
} from './actions';
//operations
import {
	pendingOperation,
	rejectedOperation,
	createTeamMemberOperation,
	deleteTeamMemberOperation,
	updateTeamMemberRoleOperation,
	generatePasswordOperation,
	getTeamMemberOperation,
} from './operations';
//constants
import {initialOrganizationData} from '@/utils/constants';

export const initialState: IOrganizationTeamReducer = {
	teamMember: null,
	teamData: initialOrganizationData,
	password: '',
	isLoading: false,
};

const organizationTeamStore = createSlice({
	name: 'organizationTeam',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getTeamMembers.pending, pendingOperation);
		builder.addCase(getTeamMembers.fulfilled, getTeamMemberOperation);
		builder.addCase(getTeamMembers.rejected, rejectedOperation);

		builder.addCase(createTeamMember.pending, pendingOperation);
		builder.addCase(createTeamMember.fulfilled, createTeamMemberOperation);
		builder.addCase(createTeamMember.rejected, rejectedOperation);

		builder.addCase(updateMemberRole.pending, pendingOperation);
		builder.addCase(updateMemberRole.fulfilled, updateTeamMemberRoleOperation);
		builder.addCase(updateMemberRole.rejected, rejectedOperation);

		builder.addCase(deleteTeamMember.pending, pendingOperation);
		builder.addCase(deleteTeamMember.fulfilled, deleteTeamMemberOperation);
		builder.addCase(deleteTeamMember.rejected, rejectedOperation);

		builder.addCase(createTeamMemberPassword.pending, pendingOperation);
		builder.addCase(createTeamMemberPassword.fulfilled, generatePasswordOperation);
		builder.addCase(createTeamMemberPassword.rejected, rejectedOperation);
	},
});

export default organizationTeamStore.reducer;
